module.exports = __webpack_public_path__ + "media/images/short_scenario_contest/theme-title@3x-91c0ed8f48ce34c1e2d2051eb9a90ac6.png";